import ProjectCard from "./ProjectCard";
import { projects, otherProjects } from "../constants/constants";
import { motion } from 'framer-motion';
import { textVariant } from "../utils/motion";
import { useState } from "react";
import ProjectModal from "./ProjectModal";
import { styles } from "../styles";

const Projects = () => {
    const [selectedProject, setSelectedProject] = useState(null);
    const [index, setIndex] = useState(0);

    const handleProjectSelection = (project) => {
        setSelectedProject(project);
        setIndex(0);
    }

    return (
        <motion.section id="projects" className="px-10 py-20">
            <motion.div variants={textVariant()} className="text-center">
                <p className={styles.sectionSubText}>{projects.heading}</p>
                <h2 className={styles.sectionHeadText}>{projects.subtext}</h2>
            </motion.div>

            <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-10 justify-items-center">
                {projects.list.map((project) => (
                    <div
                        key={project.title}
                        onClick={() => handleProjectSelection(project)}
                        className="cursor-pointer"
                    >
                        <ProjectCard {...project} />
                    </div>
                ))}
            </div>

            <div className="mt-20 px-4">
                <h3 className="text-xl font-semibold mb-4 text-center">Other Projects</h3>
                <ul className="flex flex-col gap-2 text-center text-sm md:text-base">
                    {otherProjects.map((proj) => (
                        <li key={proj.title}>
                            <a
                                href={proj.url}
                                target="_blank"
                                className="text-secondary hover:underline"
                            >
                                {proj.title}
                            </a>
                            {proj.description && (
                                <span className="text-white/70 ml-2">{proj.description}</span>
                            )}
                        </li>
                    ))}
                </ul>
            </div>

            <ProjectModal
                project={selectedProject}
                onClose={() => handleProjectSelection(null)}
                index={index}
                setIndex={setIndex}
            />
        </motion.section>
    );
};

export default Projects;